if (!window.marikaQuantityDiscountInit) {
  window.marikaQuantityDiscountInit = true;

  function getTiers() {
    return Array.from(document.querySelectorAll('[data-marika-qty-tier]'))
      .map((el) => ({
        el,
        minQuantity: parseInt(el.dataset.minQuantity, 10) || 0,
        percentOff: parseInt(el.dataset.percentOff, 10) || 0,
      }))
      .sort((a, b) => a.minQuantity - b.minQuantity);
  }

  function updateTiers(tiers, quantity) {
    let activeTier = null;
    tiers.forEach((tier) => {
      const isActive = quantity >= tier.minQuantity;
      tier.el.classList.toggle('is-active', isActive);
      if (isActive) activeTier = tier;
    });
    return activeTier;
  }

  function buildMessage(tiers, quantity, activeTier) {
    const nextTier = tiers.find((tier) => tier.minQuantity > quantity);
    const strings = window.marikaQuantityDiscountStrings || {};

    if (activeTier && !nextTier) {
      return (strings.maxTier || 'You unlocked our best discount: __PERCENT__% off!').replace(
        '__PERCENT__',
        activeTier.percentOff
      );
    }

    if (activeTier && nextTier) {
      const remaining = nextTier.minQuantity - quantity;
      return (strings.currentAndNext || 'You got __PERCENT__% off! Buy __REMAINING__ more to get __NEXT_PERCENT__% off')
        .replace('__PERCENT__', activeTier.percentOff)
        .replace('__REMAINING__', remaining)
        .replace('__NEXT_PERCENT__', nextTier.percentOff);
    }

    if (!activeTier && nextTier) {
      const remaining = nextTier.minQuantity - quantity;
      return (strings.upsell || 'Buy __REMAINING__ more to get __NEXT_PERCENT__% off')
        .replace('__REMAINING__', remaining)
        .replace('__NEXT_PERCENT__', nextTier.percentOff);
    }

    return null;
  }

  function initToast(toast) {
    let hideTimeout = null;
    return function showToast(text) {
      if (!text) {
        toast.classList.remove('is-visible');
        return;
      }
      toast.textContent = text;
      toast.classList.add('is-visible');
      window.clearTimeout(hideTimeout);
      hideTimeout = window.setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 4000);
    };
  }

  function init() {
    const tierList = document.querySelector('[data-marika-qty-tier-list]');
    const toast = document.querySelector('[data-marika-qty-toast]');
    const quantityInput = document.querySelector('.quantity__input');
    if (!tierList || !quantityInput) return;

    const tiers = getTiers();
    if (!tiers.length) return;

    const showToast = toast ? initToast(toast) : () => {};
    let lastQuantity = null;

    function handleQuantityChange(showNotification) {
      const quantity = parseInt(quantityInput.value, 10) || 1;
      if (quantity === lastQuantity) return;
      lastQuantity = quantity;

      const activeTier = updateTiers(tiers, quantity);
      if (showNotification) {
        showToast(buildMessage(tiers, quantity, activeTier));
      }
    }

    // Reflect the starting quantity immediately (no toast on first paint —
    // only once the shopper actually changes the value).
    handleQuantityChange(false);

    ['input', 'change'].forEach((eventName) => {
      quantityInput.addEventListener(eventName, () => handleQuantityChange(true));
    });

    // Dawn's quantity +/- buttons update the input's value programmatically
    // and dispatch their own 'change' event, so the listener above already
    // covers them; this MutationObserver is a safety net for any path that
    // sets .value without dispatching an event at all.
    const observer = new MutationObserver(() => handleQuantityChange(true));
    observer.observe(quantityInput, { attributes: true, attributeFilter: ['value'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}
